import * as AdminNestActions from "./AdminNestActions";
import * as AdminCouponActions from "./AdminCouponActions";
import * as AdminMapActions from "./AdminMapActions";
import * as AdminStatsActions from "./AdminStatsActions";
import * as AdminMembersActions from "./AdminMembersActions";
import * as AdminPenpalActions from "./AdminPenpalActions";
//Index of Actions

import * as LoginActions from "./LoginActions";

export const ActionCreators = Object.assign(
  {},
  AdminNestActions,
  AdminCouponActions,
  AdminMapActions,
  AdminStatsActions,
  LoginActions,
  AdminMembersActions,
  AdminPenpalActions,
);
